/** @format */
import { useLayoutEffect } from "react";
import mochiImage from "../assets/images/mochiVayTay.png";
import ButtonCircle from "../component/common/button/ButtonCircle";

const FirstScreen = ({ setPageLoginSignup }) => {
    return (
        <div className="wrap_firstScreen">
            <div className="firstScreen_image">
                <img src={mochiImage} alt="mochi image say hi" />
            </div>
            <div className="firstScreen_content">
                <div className="firstScreen_content_wrap">
                    <div className="firstScreen_content_wrap_title">
                        <div>MochiMochi chào bạn thân mến!</div>
                        <div>Để nạp mã, vui lòng đăng nhập vào tài khoản</div>
                    </div>
                    <div className="firstScreen_content_wrap_buttons">
                        <ButtonCircle
                            height={45}
                            onClick={() => {
                                setPageLoginSignup((prev) => [
                                    "login",
                                    ...prev,
                                ]);
                            }}
                            green={"true"}
                            buttonText="Đăng nhập"
                        />
                        <ButtonCircle
                            height={45}
                            onClick={() => {
                                setPageLoginSignup((prev) => [null, ...prev]);
                            }}
                            color="black"
                            white={"true"}
                            buttonText="Tạo tài khoản mới"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default FirstScreen;
